import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModalOptions, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { ConvertObjectPipe } from "../../../../../util/pipes/ConvertObjectPipe";
import { AccountPageable } from "../../../../../model/dto/bookkeping/AccountPageable";
import { AccountProvider } from "../../../../../providers/account/account";
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';


@Component({
  selector: 'app-conta-individual',
  templateUrl: './conta-individual.component.html',
  styleUrls: ['./conta-individual.component.scss']
})
export class ContaIndividualComponent implements OnInit {
  @Input() public edit;
  @Input() public planAccount;

  public enviando = false;
  public conta = new FormControl();

  protected _onDestroy = new Subject<void>();

  public accountLeafPage: number = 0;
  public leafLoaded: boolean = false;
  public filter_planAccount: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public accountPlanFilterCtrl: FormControl = new FormControl();
  public isSearchingAccount = false;
  public accountSearchInitialized = false;
  public isSelectAccountOpen = false;

  constructor(public activeModal: NgbActiveModal, public modalService: NgbModal, public planAccountProvider: AccountProvider) {
  }

  ngOnInit() {
    this.conta.setValue(this.edit);
    this.initializeAccountPlanSearch();
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  initializeAccountPlanSearch() {
    if (this.accountSearchInitialized) {
      return;
    }
    this.accountSearchInitialized = true;

    this.accountPlanFilterCtrl.valueChanges
      .pipe(
        tap(() => {
          if (this.isSelectAccountOpen) {
            this.isSearchingAccount = true;
          }
        }),
        debounceTime(250),
        distinctUntilChanged(),
        switchMap(searchTerm => {
          this.accountLeafPage = 0;
          return this.planAccountProvider.getAllAccountsLeafsByPage(searchTerm || '', 0);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe((categorias: AccountPageable[]) => {
        this.isSearchingAccount = false;

        this.leafLoaded = categorias['last'];
        this.accountLeafPage = 1;
        const pipe = new ConvertObjectPipe();
        const newItems = pipe.transform(categorias['content'], 'categoria');
        this.planAccount.length = 0;

        const searchTerm = (this.accountPlanFilterCtrl.value || '').trim();
        if (!searchTerm && this.conta.value) {
          this.planAccount.push(this.conta.value);
        }
        this.planAccount.push(...newItems);
        this.filter_planAccount.next(this.planAccount.slice());
      });
  }

  onSelectKeydown(event: KeyboardEvent) {
    if (this.isSearchingAccount && event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onSelectOpenedChange(isOpen: boolean) {
    this.isSelectAccountOpen = isOpen;
    if (isOpen) {
      this.getLeafsFirstPage();
      this.isSearchingAccount = false;
    } else {
      this.isSearchingAccount = false;
    }
  }

  getLeafsFirstPage() {
    this.isSearchingAccount = false;
    const currentValue = this.accountPlanFilterCtrl.value;
    this.accountPlanFilterCtrl.setValue(currentValue || '', { emitEvent: true });
  }

  getLeafsNextBatch() {
    const search = this.accountPlanFilterCtrl.value || '';
    const panels = Array.from(document.querySelectorAll('.mat-select-panel')) as HTMLElement[];
    const currentPanel = panels.length > 0 ? panels[panels.length - 1] : null;
    const previousScrollTop = currentPanel ? currentPanel.scrollTop : null;

    this.planAccountProvider.getAllAccountsLeafsByPage(search, this.accountLeafPage).then((categorias: AccountPageable[]) => {
      this.leafLoaded = categorias['last'];
      this.accountLeafPage++;
      const pipe = new ConvertObjectPipe();
      const newItems = pipe.transform(categorias['content'], 'categoria');
      this.planAccount.push(...newItems);
      this.filter_planAccount.next(this.planAccount.slice());

      if (currentPanel && previousScrollTop !== null) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            currentPanel.scrollTop = previousScrollTop;
          });
        });
      }
    });
  }

  save() {
    this.activeModal.close(this.conta.value);
  }
}
